import Chip from '@/components/Layout/Chip';
import ImageComponent from '@/components/Layout/Image';
import currencyParser from '@/utils/currencyParser';
import getConfig from 'next/config';
import styles from './MoreAbout.module.css';

const { publicRuntimeConfig } = getConfig();

interface MoreAboutProps {
  type: 'empresa' | 'celebridade' | 'produto';
  dados: {
    cu: number;
    titulo: string;
    url: string;
    imagem: {
      url: string;
      blurhash: string;
      dimensao: string;
    };
  };
  isSubDomain?: boolean;
  product?: {
    preco: number;
    encurtador: string;
  };
}

export default function MoreAbout({ type = 'empresa', dados, isSubDomain = false, product = null }: MoreAboutProps) {
  let texto = 'ver mais';
  if (type === 'produto') texto = 'ficha técnica';

  const sponsoredBrandUrl = '/empresa/oppo/';

  const isSponsoredBrand = dados.url === sponsoredBrandUrl;

  const backgroundOppo = 'https://t.ctcdn.com.br/QFdnjPQOAnsY-aHSkABkXT-BcN4=/i1068821.jpeg';

  return (
    <div className={`mb-8 shadow-mdc-elevation-z9-3 ${isSponsoredBrand ? styles.animatedBorder : ''}`}>
      <div
        className={`relative flex flex-row items-center justify-between gap-4 rounded-md p-4 ${isSponsoredBrand ? "z-[2] h-[116px] overflow-hidden before:absolute before:bottom-0 before:left-0 before:right-0 before:top-0 before:z-[1] before:rounded-md before:bg-black/60 before:content-['']" : 'z-[2] bg-mglGray50'}`}>
        {isSponsoredBrand && (
          <div className="absolute inset-0 h-full w-full">
            <ImageComponent className="opacity-60" src={backgroundOppo} alt={dados.titulo} />
          </div>
        )}

        <div className={`flex items-center gap-2 ${isSponsoredBrand ? 'relative z-[2] w-full' : ''}`}>
          <div className="h-14 w-14 rounded border border-solid border-mglGray200 bg-mglGray50 phone:h-[4.625rem] phone:w-[4.625rem] [&_figure]:p-0 [&_figure]:phone:p-2">
            <ImageComponent src={dados.imagem.url} blurhash={dados.imagem.blurhash} alt={dados.titulo} />
          </div>
          <span className={`${isSponsoredBrand ? 'flex-1 text-center text-lg font-bold text-mglGray50 sm:text-xl lg:text-2xl' : 'ml-2 flex-1'}`}>
            {type === 'empresa' && 'Tudo sobre'} {dados.titulo}
          </span>
        </div>

        <div
          className={`flex flex-col gap-1 tablet:flex-row desktop:flex-col largeDesktop:flex-row [&>a]:h-9 [&>a]:rounded-[20px] ${isSponsoredBrand ? 'relative z-[2]' : ''}`}>
          {product && (
            <div className="[&>a]:h-9 [&>a]:hover:bg-mglGreen600">
              <Chip
                chipSize="medium"
                color="white"
                hover="green"
                highlightedText={currencyParser(product.preco)}
                texto="melhor preço"
                link={product.encurtador}
              />
            </div>
          )}
          <Chip
            texto={texto}
            chipSize={isSponsoredBrand ? 'large' : 'medium'}
            color={isSponsoredBrand ? 'white' : 'black'}
            hover={isSponsoredBrand ? 'white' : 'black'}
            borderColor={isSponsoredBrand ? 'white' : 'black'}
            posIcon={isSponsoredBrand ? 'chevron-right' : ''}
            link={isSubDomain ? `${publicRuntimeConfig.NEXT_PUBLIC_URL}${dados.url}` : dados.url}
          />
        </div>
      </div>
    </div>
  );
}
